import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import attachRecommendationFolder from '../attachRecommendationFolder';
import attachRecommendationDocument from '../attachRecommendationDocument';
import attachRecommendationReportFolder from '../attachRecommendationReportFolder';
import attachRecommendationReport from '../attachRecommendationReport';
import controller from './attach-recommendation-dialog.controller';
import template from './attach-recommendation-dialog.html';


class dialogService {
  getOptions($event, { serviceId, recommendationId, folder }) {
    return {
      controller,
      controllerAs: 'attachRecommendationDialogVM',
      locals: {
        serviceId,
        recommendationId,
        folder
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.attachRecommendationDialog', [
  alerts,
  amDataService,
  attachRecommendationDocument,
  attachRecommendationFolder,
  attachRecommendationReport,
  attachRecommendationReportFolder,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .service('attachRecommendationDialog', dialogService)
  .name;
